<template>
  <div class="lgrm-proof-widget" :id="'lg-proof-widget-' + campaign.id">
    <div class="lgrm-proof-container">
      <div class="lgrm-proof-highlight" :style="lgrmProofHighlight">
        <ResponseRatingAnswerDisplay
          v-if="!isMap"
          :answer="message.number"
          :type="message.metric_type"
          :ratingColors="colors"
          :ratingLabels="getRatingLabels(message.metric_type)"
          :size="75"
          :emojiSize="50"
          :labelStyle="{
            'display': 'none'
          }"
        ></ResponseRatingAnswerDisplay>
        <img
          class="lgrm-location-map"
          v-if="isMap"
          :src="
            'https://maps.googleapis.com/maps/api/staticmap?center=' +
              message.location +
              '&zoom=10&size=100x100&maptype=roadmap&markers=color:' + markerColor  + '%7Csize:mid%7C' +
              message.cords[0] +
              ',' +
              message.cords[1] +
              '&key=AIzaSyDeecTe9mRhPMN6MkHwh4Ytc9ABCSrWQTQ'
          "
        />
      </div>
      <div class="lgrm-proof-content">
        <div class="lgrm-user-info">{{ message.user }}</div>
        <div class="lgrm-user-msg" v-html="message.message"></div>
        <div class="lgrm-msg-date">
          {{ getDate(message.time) }}
        </div>
      </div>
      <img
        :src="require('../../assets/close-proof.png')"
        class="lgrm-close"
        @click="close"
      />

      <div class="lgrm-verified">
        <img :src="require('../../assets/verified.png')" /> by
        <a href="https://loyagram.com" target="_blank">Loyagram</a>
      </div>
    </div>
  </div>
</template>

<script>
import strings from '../../../../../src/strings'

import distanceInWords from 'date-fns/distance_in_words'
import ResponseRatingAnswerDisplay from '../../../../../src/components/insights/ResponseRatingAnswerDisplay'
export default {
  name: 'ProofWidget',
  components: { ResponseRatingAnswerDisplay },
  mixins: [],
  props: {
    campaign: Object,
    message: Object
  },
  data() {
    const color = this.campaign.proof.primary_color || '#57BB8A'
    return {
      msgIndex: 0,
      colors: {
        rated1: color,
        rated2: color,
        rated3: color,
        rated4: color,
        rated5: color
      }
    }
  },
  computed: {
    isMap: function() {
      /*
        NPS_RATING, NPS_LABEL
        SAT_RATING, SAT_LABEL
        ES_RATING, ES_LABEL */
        
      return (
        ['NPS_LABEL', 'SAT_LABEL', 'ES_LABEL'].indexOf(
          this.message.message_type
        ) > -1
      )
    },
    lgrmProofHighlight() {
      return {
        background: this.campaign.proof.primary_color || '#57BB8A'
      }
    },
    markerColor(){
      const color = this.campaign.proof.primary_color || '#57BB8A'
      return '0x' + color.slice(1)
    }
  },
  methods: {
    close: function() {
      this.$emit('close')
    },
    getRatingLabels: function(type) {
      if (type === 'NPS') {
        return {
          rated1: null,
          rated2: null,
          rated3: null,
        }
      } else if (type === 'SAT') {
        return {
          rated1: null,
          rated2: null,
          rated3: null,
          rated4: null,
          rated5: null,
        }
      } else {
        return {
          rated1: null,
          rated2: null,
          rated3: null,
          rated4: null,
          rated5: null,
        }
      }
    },
    getDate(dte) {
      return distanceInWords(new Date(), new Date(dte * 1000), {
        includeSeconds: true,
        addSuffix: true
      })
    }
  }
}
</script>

<style lang="stylus">

.lgrm-proof-widget
  font-family 'Proxima Nova' !important
  width 360px
  min-height 100px
  text-shadow none
  overflow-y auto
  color: $proof-color-primary
  box-sizing border-box
  default-box-shadow()
  border 1px solid #F1F2F6
  border-radius 5px
  background #fff
  display table
  @media (max-width 400px) {
    width 300px
    min-height 60px
  }
  img, svg {
      display inline-block
      
  }

  .lgrm-proof-container
      min-height 100px
      position: relative
      box-sizing border-box
      overflow hidden
      text-overflow ellipsis

  .lgrm-proof-highlight
      width 100px
      height 100%
      border-top-left-radius 5px
      border-bottom-left-radius 5px
      display inline-block
      position absolute
      top: 0
      left 0
      .lgrm-emoji-display
          padding 0
          .lgrm-emoji-label
              display none

      .lgrm-nps-score
          font-size: 36px;
          font-weight 500

      .lgrm-location-map
          border-top-left-radius 5px
          border-bottom-left-radius 5px
          

  .lgrm-proof-content
      display inline-block
      width 100%
      height 100px
      padding 10px 10px 5px 120px
      box-sizing border-box

      .lgrm-user-info
          font-size 12px
          font-weight 500
          color: $proof-color-secondary-text
          margin-bottom 8px
          max-height 14px

      .lgrm-user-msg
          font-size 13px
          font-weight 500
          color: $proof-color-primary-text
          line-height 1.25
          display: table-cell;
          vertical-align: middle
          height 40px

      /*.lgrm-brand-name, .lgrm-rating-text*/
      /*font-weight bold*/

      .lgrm-msg-date
          color: #B7B7B7
          font-size: 12px
          font-weight 500
          position: absolute
          bottom: 4px

  .lgrm-close
      position: absolute
      right 5px
      top 5px
      cursor pointer
      display none

  &:hover
      .lgrm-close
          display inline-block

  .lgrm-verified
      position absolute
      right 12px
      bottom: 4px
      font-size 12px
      font-weight 500
      color: #B7B7B7
      img 
        vertical-align middle
      a
          color inherit
          text-decoration none
          font-weight normal
          font-family 'Proxima Nova'
</style>
